import { IApplicationState } from '../../types/redux';

export const promoOffersIdsSelector = (state: IApplicationState) => {
  return state.promoOffersSelection.offersIds;
};

export const selectPromoOffer = (state: IApplicationState, cardId: number) => {
  return state.promoOffersSelection.offers[cardId];
};

export const selectPromoOffers = (state: IApplicationState) => {
  return state.promoOffersSelection.offers;
};
